// Ações puras do sudoku.
//
// São só três (§6), e a razão é a D1: sudoku é matematicamente restrito, então o
// admin não desenha do zero — ele GERA (o que garante solução única de saída) e
// depois ajusta QUAIS casas vêm preenchidas, que é a alavanca real de dificuldade.
//
// Regra do shell: quando a ação não muda nada, devolver a MESMA referência do doc —
// é assim que o history sabe que não tem o que empilhar.

import { type SudokuDoc, type SudokuDificuldade } from './doc';
import { generateGrid } from './solver';

export type SudokuAction =
  | { type: 'SET_TITULO'; titulo: string }
  /** Alterna "esta casa vem preenchida?" — nunca mexe na solução. */
  | { type: 'TOGGLE_GIVEN'; index: number }
  /** Sorteia um tabuleiro novo inteiro. Entrada própria no undo (S6). */
  | { type: 'GENERATE'; dificuldade: SudokuDificuldade };

export function sudokuReducer(doc: SudokuDoc, action: SudokuAction): SudokuDoc {
  switch (action.type) {
    case 'SET_TITULO':
      return action.titulo === doc.titulo ? doc : { ...doc, titulo: action.titulo };

    case 'TOGGLE_GIVEN': {
      const { index } = action;
      if (!Number.isInteger(index) || index < 0 || index >= doc.shape.size * doc.shape.size)
        return doc;
      const givens = [...doc.givens];
      givens[index] = !givens[index];
      return { ...doc, givens };
    }

    case 'GENERATE': {
      // O gerador só sabe sortear 9×9; num 15×15 a ação é no-op (a UI desabilita o botão).
      if (doc.shape.size !== 9) return doc;
      // O sorteio mora aqui mesmo, e não no componente, para que "gerar" seja uma
      // AÇÃO do documento — só assim ela entra no histórico e o admin desfaz um
      // "Gerar" clicado sem querer (S6). Mesmo padrão do FILL_RANDOM do
      // caça-palavras: o reducer é determinístico em tudo menos no sorteio, e os
      // testes cobram as invariantes (tabuleiro válido, solução única) e não os
      // dígitos.
      const { solution, givens } = generateGrid(action.dificuldade);
      return { ...doc, solution, givens, dificuldade: action.dificuldade };
    }

    default:
      return doc;
  }
}
